export default __webpack_public_path__ + "static/media/trainer_2.69b02e15.PNG";